/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getPaymentMethodsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc',
  rpcName: 'getPaymentMethods',
  auth: 'external',
  fingerprint: 'w240K-5axTxVJfn9TZGDppwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCurrentSubscriptionsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc',
  rpcName: 'getCurrentSubscriptions',
  auth: 'external',
  fingerprint: 'f7pfX2RjwINmMMyaoka-W5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInactiveSubscriptionsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc',
  rpcName: 'getInactiveSubscriptions',
  auth: 'external',
  fingerprint: 'f7pfX2RjwINmMMyaoka-W5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInvoicesRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc',
  rpcName: 'getInvoices',
  auth: 'external',
  fingerprint: 'm13P0VQSusQGd3CqjHcMLpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCommercePaymentsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc',
  rpcName: 'getCommercePayments',
  auth: 'external',
  fingerprint: '26plkz_5aD7IwQOYA0p5z5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getFailedCommercePaymentsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc',
  rpcName: 'getFailedCommercePayments',
  auth: 'external',
  fingerprint: 'wzIIIZ-UmVz8XD7bwsLRa5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};